'use client';

import { useConvexAuth } from 'convex/react';
import { useEffect } from 'react';
import {
  clearedReferralCookie,
  referralCodeFromSearch,
  referralCookie,
} from '@/lib/referrals/pending-referral-code';

/**
 * Keeps `?ref=<invite code>` in a cookie while the visitor is signed out, so
 * the account they create next carries it (#6938). Once anyone is signed in
 * in this browser the cookie is cleared: attribution only ever attaches at
 * account creation, server-side, and never to an account switched to later.
 */
export function ReferralCodeCapture() {
  const { isAuthenticated, isLoading } = useConvexAuth();

  useEffect(() => {
    if (isLoading) return;
    const secure = window.location.protocol === 'https:';
    try {
      if (isAuthenticated) {
        if (document.cookie.includes('imai_ref=')) {
          document.cookie = clearedReferralCookie(secure);
        }
        return;
      }
      const code = referralCodeFromSearch(window.location.search);
      if (code) document.cookie = referralCookie(code, secure);
    } catch {}
  }, [isAuthenticated, isLoading]);

  return null;
}
